var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCartMainItem } from '../Providers';
import { breakpoints } from '../breakpoints';
import { Hidden } from '../UI/Hidden';
export var OrderSummaryOverview = function () {
    return (_jsx(OrderSummaryOverviewWrapper, { children: _jsx(Hidden, __assign({ "$mobileOnly": true }, { children: _jsx(MainItemImage, {}) })) }));
};
var MainItemImage = function () {
    var mainItem = useCartMainItem();
    if (mainItem) {
        return _jsx(Image, { src: mainItem.image, alt: mainItem.name });
    }
    return null;
};
var Image = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 50%;\n  margin: var(--spacing) auto;\n"], ["\n  width: 50%;\n  margin: var(--spacing) auto;\n"])));
var OrderSummaryOverviewWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n\n  p {\n    color: var(--checkout-gray600);\n    font-size: var(--checkout-font-size-16);\n    font-weight: 500;\n  }\n\n  h4 {\n    color: var(--checkout-text-font-color);\n    font-size: var(--checkout-font-size-36);\n    margin-bottom: calc(3 * var(--spacing));\n    font-weight: 600;\n  }\n\n  @media screen and (min-width: ", ") {\n    text-align: left;\n  }\n"], ["\n  text-align: center;\n\n  p {\n    color: var(--checkout-gray600);\n    font-size: var(--checkout-font-size-16);\n    font-weight: 500;\n  }\n\n  h4 {\n    color: var(--checkout-text-font-color);\n    font-size: var(--checkout-font-size-36);\n    margin-bottom: calc(3 * var(--spacing));\n    font-weight: 600;\n  }\n\n  @media screen and (min-width: ", ") {\n    text-align: left;\n  }\n"
    // const OrderSummaryName = () => {
    //   const { businessName } = useBusiness()
    //   return <p>Pay {businessName}</p>
    // }
    // const OrderSummaryTotal = () => {
    //   const { formattedTotal } = useCartTotal()
    //   return <h4>{formattedTotal}</h4>
    // }
])), breakpoints.main);
var templateObject_1, templateObject_2;
//# sourceMappingURL=Overview.js.map